import {Component, OnInit} from '@angular/core';
import {Penalidade} from "../penalidade/penalidade";
import {Evento} from "../eventos/evento";
import {Trabalho} from "../trabalho/trabalho";
import {Router} from "@angular/router";
import {AppComponent} from "../app.component";

@Component({
	selector: 'app-penalidade',
	templateUrl: './penalidade.component.html',
	styleUrls: ['./penalidade.component.css']
})

export class PenalidadeComponent extends AppComponent implements OnInit {
	penalidade: Penalidade;
	evento: any;
	propostas: Trabalho[]
	carregado: boolean = false;
	service = this.penalidadeService;
	id: number;

	ngOnInit() {
		if (!this.isAdmin()) 
			this.router.navigateByUrl('inicio');
        else {
			this.route.params.subscribe(params => this.id = parseInt(params['id']));
			if (this.id) {
				this.penalidadeService.show(this.id).then(penalidade => {
					this.evento = penalidade.trabalho.evento;
					this.propostas = this.evento.trabalhos;
					this.penalidade = new Penalidade();
					this.penalidade.usuario_id = this.user_id;
					this.penalidade.id = penalidade.id;
					this.penalidade.motivo = penalidade.motivo;
					this.penalidade.trabalho_id = penalidade.trabalho_id;
					this.penalidade.desconto = penalidade.desconto;
					this.carregado = true;
				});
			}
			else { 
				this.eventoService.buscarUltimo().then(evento => {
					this.evento = evento;
					this.propostas = evento.trabalhos;
					this.penalidade = new Penalidade();
					this.penalidade.usuario_id = this.user_id;
					this.carregado = true;
				});
			}
		}
	}
	
	onSubmit() {
		if (this.id)
			this.update(this.penalidade);
		else
			this.submit(this.penalidade);
	}

}



// WEBPACK FOOTER //
// ./src/app/penalidade/penalidade.component.ts